import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class E11TitleBarComponent {
    constructor() {
        this.width = 'full';
        this.headerBgColor = 'e11-bg-skin-primary';
        this.headerStyle = 'rounded-top';
        this.hasBorder = false;
        this.hasShadow = true;
        this.headerText = 'Header Text';
        this.headerTemplate = null;
        this.contentClassOverrides = 'e11-p-4'; // default padding
        this.ctaClicked = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TitleBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11TitleBarComponent, selector: "e11-title-bar", inputs: { width: "width", headerBgColor: "headerBgColor", headerStyle: "headerStyle", hasBorder: "hasBorder", hasShadow: "hasShadow", headerText: "headerText", headerTemplate: "headerTemplate", containerClassOverrides: "containerClassOverrides", contentClassOverrides: "contentClassOverrides" }, outputs: { ctaClicked: "ctaClicked" }, ngImport: i0, template: "<div\n  class=\"e11-title-bar e11-rounded-lg e11-px-4 e11-py-2 {{ headerBgColor }} {{ containerClassOverrides }} \"\n  [ngClass]=\"{\n    'e11-w-[20%]': width === 'xs',\n    'e11-w-[30%]': width === 'sm',\n    'e11-w-[50%]': width === 'md',\n    'e11-w-[60%]': width === 'lg',\n    'e11-w-[80%]': width === 'xl',\n    'e11-w-full': width === 'full' || '',\n    'e11-shadow-md': hasShadow,\n    'e11-border e11-border-skin-app-borders': hasBorder,\n    'e11-rounded-t-lg': headerStyle === 'rounded-top',\n    'e11-rounded-none': headerStyle === 'square',\n    'e11-rounded-lg': headerStyle === 'rounded'\n  }\"\n>\n  <ng-container *ngIf=\"headerTemplate\" [ngTemplateOutlet]=\"headerTemplate\"></ng-container>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TitleBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-title-bar', encapsulation: ViewEncapsulation.None, template: "<div\n  class=\"e11-title-bar e11-rounded-lg e11-px-4 e11-py-2 {{ headerBgColor }} {{ containerClassOverrides }} \"\n  [ngClass]=\"{\n    'e11-w-[20%]': width === 'xs',\n    'e11-w-[30%]': width === 'sm',\n    'e11-w-[50%]': width === 'md',\n    'e11-w-[60%]': width === 'lg',\n    'e11-w-[80%]': width === 'xl',\n    'e11-w-full': width === 'full' || '',\n    'e11-shadow-md': hasShadow,\n    'e11-border e11-border-skin-app-borders': hasBorder,\n    'e11-rounded-t-lg': headerStyle === 'rounded-top',\n    'e11-rounded-none': headerStyle === 'square',\n    'e11-rounded-lg': headerStyle === 'rounded'\n  }\"\n>\n  <ng-container *ngIf=\"headerTemplate\" [ngTemplateOutlet]=\"headerTemplate\"></ng-container>\n</div>\n" }]
        }], propDecorators: { width: [{
                type: Input
            }], headerBgColor: [{
                type: Input
            }], headerStyle: [{
                type: Input
            }], hasBorder: [{
                type: Input
            }], hasShadow: [{
                type: Input
            }], headerText: [{
                type: Input
            }], headerTemplate: [{
                type: Input
            }], containerClassOverrides: [{
                type: Input
            }], contentClassOverrides: [{
                type: Input
            }], ctaClicked: [{
                type: Output
            }] } });

class E11TitleBarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TitleBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11TitleBarModule, declarations: [E11TitleBarComponent], imports: [CommonModule], exports: [E11TitleBarComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TitleBarModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TitleBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11TitleBarComponent],
                    imports: [CommonModule],
                    exports: [E11TitleBarComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11TitleBarComponent, E11TitleBarModule };
